import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import getStudyFullYear from "../../services/datetime/getStudyFullYear";
import getCustomYear from "../../services/datetime/getCustomYear";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  title: {
    padding: theme.spacing(1),
  },
}));

export const InfoText = () =>  {
  const classes = useStyles();
  const customYear = getCustomYear(new Date());
  const currentStudyYear = getStudyFullYear(new Date());
  const nextStudyYear = currentStudyYear + 1;
  return (
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                <List>
                  <ListItem style={{ paddingBlock: "0" }}>
                    <ListItemText>
                      <Typography
                        align="center"
                        variant="h6"
                        component="p"
                        style={{ marginBlockEnd: "1rem" }}
                      >
                        Уважаемый абитуриент {customYear}!
                      </Typography>
                      <Typography
                        align="justify"
                        variant="body1"
                        component="p"
                        style={{ marginBlockEnd: "1rem" }}
                      >
                        Учреждение образования «Гродненский государственный
                        университет имени Янки Купалы» приветствует Вас в числе
                        потенциальных абитуриентов Купаловского университета{" "}
                        {customYear} года.
                      </Typography>
                      <Typography
                        align="justify"
                        variant="body1"
                        component="p"
                        style={{ fontWeight: "700" }}
                      >
                        Цифровой кабинет абитуриента поможет Вам:
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem style={{ paddingBlock: "0" }}>
                    <ListItemText>
                      <Typography align="justify" variant="body1" component="p">
                        • выбрать факультет(ы) и специальность(и), поступление
                        на которые планируете в дальнейшем (раздел меню
                        «Профиль»);
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <Typography align="justify" variant="body1" component="p">
                        • зарегистрироваться и принять участие в многопрофильной
                        университетской олимпиаде Купаловского университета в {currentStudyYear}/{nextStudyYear} учебном году (раздел меню «Многопрофильная
                        олимпиада»);
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <Typography align="justify" variant="body1" component="p">
                        • получать онлайн-консультации (в течение одного
                        рабочего дня) по вопросам поступления в университет
                        (раздел меню «Чат»);
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemText>
                      <Typography align="justify" variant="body1" component="p">
                        • получать новостную рассылку о новшествах вступительной
                        кампании {customYear} года, а также анонсы профориентационных
                        мероприятий факультетов и университета (раздел меню
                        «Новости»).
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem style={{ paddingBlock: "0" }}>
                    <ListItemText>
                      <Typography
                        align="center"
                        variant="h6"
                        component="p"
                        style={{ marginBlockEnd: "1rem" }}
                      >
                        Желаем успехов!
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

  );
}